module.exports = __webpack_public_path__ + "static/media/Post-Optim.f879cff9.jpg";